import { Box, Button, Grid, IconButton, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { BsInfoCircle } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom"
import useAuth from "../../context/auth";
import { Format } from "../../utils";
import { CgFileDocument } from "react-icons/cg";
import { LineComponent } from "../../components/line";
import { MyRent } from "../dashboard/tabs/rent/components/myRent";
import { ModalContract } from "./modal";

export const RentDetails = () => {
    const { id } = useParams()
    const { user } = useAuth()

    const percentage = ((user?.actualContract?.parcels?.filter((item) => item.status === 10).length ?? 0) * 100) / (user?.actualContract?.parcels?.length ?? 0)

    const valuePaid = user?.actualContract?.parcels?.filter((item) => item.status === 10).reduce((prev, current) => current.groosAmount + prev, 0)
    const valuePaidCharges = user?.actualContract?.parcels?.filter((item) => item.status === 10).reduce((prev, current) => current.totalLateCharges + prev, 0)

    const valuePending = user?.actualContract?.parcels?.filter((item) => item.status !== 10).reduce((prev, current) => current.groosAmount + prev, 0)
    const valuePendingCharges = user?.actualContract?.parcels?.filter((item) => item.status !== 10).reduce((prev, current) => current.totalLateCharges + prev, 0)

    const [openModalDocument, setOpenModalDocument] = useState(false)
    return (
        <>
            <Typography fontSize={"2rem"} fontWeight={600} p={0}>Minhas diárias</Typography>

            <Grid
                display={"flex"}
                direction={"row"}
                flexWrap={"nowrap"}
                justifyContent={"space-between"}
                flex={10}
                gap={"1rem"}
            >
                <Grid
                    display={"flex"}
                    direction={"column"}
                    borderRadius={"10px"}
                    gap={".8rem"}
                    padding={"1rem .5rem"}
                    flex={5}
                    sx={{
                        backgroundColor: "#178BF126"
                    }}
                >
                    <Box
                        alignSelf={"center"}
                        width={"95%"}
                        height={"2.3rem"}
                        borderRadius={"50px"}
                        sx={{
                            position: "relative",
                            backgroundColor: "#EDEEFEBF",
                            overflow: "hidden",
                        }}
                    >
                        <Box
                            sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                height: "100%",
                                width: `${percentage}%`,
                                transition: "width .5s ease-out",
                                background: "linear-gradient(90deg, #178BF1 0%, #1D22E6 100%)",
                                borderRadius: "50px",
                            }}
                        />
                    </Box>

                    <Typography fontSize={"1.4rem"}><strong>{user?.actualContract?.parcels?.filter((item) => item.status === 10).length} de 24</strong> diárias pagas</Typography>

                    <Typography color="secondary" fontSize={"2.8rem"} fontWeight={800} lineHeight={"2.5rem"}>{Format.currency(valuePaid ?? 0)}</Typography>

                    {(valuePaidCharges ?? 0) > 0 && <Typography fontSize={"1.2rem"} sx={{ opacity: .5 }}>Adicionais: {Format.currency(valuePaidCharges ?? 0)}</Typography>}
                    {/* <IconButton><BsInfoCircle size={12} color="#000" style={{ marginTop: -3, marginLeft: -5 }} /></IconButton> */}
                </Grid>

                <Grid
                    display={"flex"}
                    direction={"column"}
                    gap={"1rem"}
                >
                    <Grid flex={5}>
                        <Grid
                            width={"100%"}
                            minHeight={"8.7rem"}
                            height={"100%"}
                            display={"flex"}
                            direction={"column"}
                            padding={"1rem .5rem"}
                            borderRadius={"10px"}
                            sx={{
                                backgroundColor: "rgba(0, 0, 0, 0.07)"
                            }}
                            gap={".8rem"}
                        >
                            <Typography fontSize={"1.4rem"}><strong>{user?.actualContract?.parcels?.filter((item) => item.status !== 10).length} de 24</strong> diárias a pagar</Typography>

                            <Typography color="#e69b1d" fontSize={"2.8rem"} fontWeight={800} lineHeight={"2.5rem"}>{Format.currency(valuePending ?? 0)}</Typography>

                            {(valuePendingCharges ?? 0) > 0 && <Typography fontSize={"1.2rem"} sx={{ opacity: .5 }}>Adicionais: {Format.currency(valuePendingCharges ?? 0)}</Typography>}
                            {/* <IconButton><BsInfoCircle size={12} color="#000" style={{ marginTop: -3, marginLeft: -5 }} /></IconButton> */}

                        </Grid>
                    </Grid>
                    <Button
                        sx={{
                            width: "100%",
                            height: "4rem"
                        }}
                        disabled={!user?.actualContract?.contract?.contractFileUrl}
                        variant="outlined"
                        startIcon={<CgFileDocument size={20} />}
                        onClick={() => setOpenModalDocument(true)}
                    >Ver contrato</Button>

                </Grid>

            </Grid>

            <LineComponent />

            <MyRent details />

            <ModalContract onClose={() => setOpenModalDocument(false)} open={openModalDocument}/>
        </>
    )
}